import { faChevronDown, faChevronUp, faSortDown, faSortUp } from '@fortawesome/free-solid-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { memo } from 'react'
import { colors } from 'settings/colors'

const activeColor = colors.grey500
const inactiveColor = colors.midnight

const SortArrows = ({
  sortOrder,
  isBeingSorted,
  type,
}: {
  sortOrder: number | null
  isBeingSorted: boolean
  type: string
}) => {
  return (
    <div
      css={{
        display: 'flex',
        flexDirection: 'column',
        position: 'absolute',
        right: type === 'values' ? '-5px' : 8,
        top: type === 'values' ? 'calc(50% - 12px)' : 'calc(50% - 2px)',
      }}
    >
      <FontAwesomeIcon
        icon={type === 'values' ? faChevronUp : faSortUp}
        css={{
          margin: type === 'values' ? 'none' : '-6px 0px',
          fontSize: '12px',
          color: isBeingSorted && sortOrder === 1 ? activeColor : inactiveColor,
          transition: '0.3s ease all',
        }}
      />
      <FontAwesomeIcon
        icon={type === 'values' ? faChevronDown : faSortDown}
        css={{
          fontSize: '12px',
          color: isBeingSorted && sortOrder === -1 ? activeColor : inactiveColor,
          transition: '0.3s ease all',
        }}
      />
    </div>
  )
}

const MemoizedSortArrows = memo(SortArrows) as typeof SortArrows

export { MemoizedSortArrows as SortArrows }
